module.exports = __webpack_public_path__ + "app/components/customers/details.view.html";